import { render, staticRenderFns } from "./SmbCheckbox.vue?vue&type=template&id=980a7c3e&scoped=true&"
import script from "./SmbCheckbox.vue?vue&type=script&lang=ts&"
export * from "./SmbCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./SmbCheckbox.scss?vue&type=style&index=0&id=980a7c3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980a7c3e",
  null
  
)

export default component.exports